<!--支付信息模块-->
<template>
  <div class="details_content_repeat">
    <QS-h4-title title="支付信息" />
    <div class="details_content_repeat_hundred">
      <column-box :source="source" :list="payInfoList" label-width="140">
      </column-box>
    </div>
  </div>
</template>

<script>
import selectOption from '@/store/dict/selectOptionDict'

export default {
  props: {
    source: {
      type: Object,
    },
  },
  watch: {
    source: {
      handler(val) {
        if (Number(val.payForm) === 1) {
          // eslint-disable-next-line vue/no-mutating-props
          this.source.payTypeName = '--'
        } else {
          // eslint-disable-next-line vue/no-mutating-props
          this.source.payTypeName = selectOption.paymenttypeDict[val.payType]
        }
        // eslint-disable-next-line vue/no-mutating-props
        this.source.payFormName = selectOption.paymentformDict[val.payForm]
        // eslint-disable-next-line vue/no-mutating-props
        this.source.billingDateName = `${val.billingDate || '--'}号`
      },
      deep: true,
    },
  },
  data() {
    return {
      // 支付信息
      payInfoList: [
        {
          key: 'payFormName',
          name: '支付方式',
        },
        {
          key: 'carTotalAmount',
          name: '合同总金额',
          finance: true,
        },
        {
          key: 'deposit',
          name: '总押金',
          finance: true,
        },
        {
          key: 'manageFee',
          name: '一次性管理费',
          finance: true,
        },
        {
          key: 'serviceFee',
          name: '其他服务费',
          finance: true,
        },
        {
          key: 'remarks',
          name: '备注',
          alone: true,
        },
      ],
    }
  },
}
</script>

<style></style>
